var t = [
  "text-xxs",
  "text-hero-xl",
  "text-hero-xl--line-height",
  "text-hero-md",
  "text-hero-md--line-height",
  "text-hero-sm",
  "text-hero-sm--line-height",
  "text-grand-xl",
  "text-grand-xl--line-height",
  "text-grand-md",
  "text-grand-md--line-height",
  "text-grand-sm",
  "text-grand-sm--line-height",
  "text-h1-xl",
  "text-h1-xl--line-height",
  "text-h1-md",
  "text-h1-md--line-height",
  "text-h1-sm",
  "text-h1-sm--line-height",
  "text-h2-xl",
  "text-h2-xl--line-height",
  "text-h2-md",
  "text-h2-md--line-height",
  "text-h2-sm",
  "text-h2-sm--line-height",
  "text-h3-xl",
  "text-h3-xl--line-height",
  "text-h3-md",
  "text-h3-md--line-height",
  "text-h3-sm",
  "text-h3-sm--line-height",
  "text-h4-xl",
  "text-h4-xl--line-height",
  "text-h4-md",
  "text-h4-md--line-height",
  "text-h4-sm",
  "text-h4-sm--line-height",
  "text-h5-xl",
  "text-h5-xl--line-height",
  "text-h5-md",
  "text-h5-md--line-height",
  "text-h5-sm",
  "text-h5-sm--line-height",
  "text-big-xl",
  "text-big-xl--line-height",
  "text-big-md",
  "text-big-md--line-height",
  "text-big-sm",
  "text-big-sm--line-height",
  "text-large-xl",
  "text-large-xl--line-height",
  "text-large-md",
  "text-large-md--line-height",
  "text-large-sm",
  "text-large-sm--line-height",
  "text-medium-xl",
  "text-medium-xl--line-height",
  "text-medium-md",
  "text-medium-md--line-height",
  "text-medium-sm",
  "text-medium-sm--line-height",
  "text-small-xl",
  "text-small-xl--line-height",
  "text-small-md",
  "text-small-md--line-height",
  "text-small-sm",
  "text-small-sm--line-height",
  "text-caption-large-xl",
  "text-caption-large-xl--line-height",
  "text-caption-large-md",
  "text-caption-large-md--line-height",
  "text-caption-large-sm",
  "text-caption-large-sm--line-height",
  "text-caption-small-xl",
  "text-caption-small-xl--line-height",
  "text-caption-small-md",
  "text-caption-small-md--line-height",
  "text-caption-small-sm",
  "text-caption-small-sm--line-height",
  "text-button-xl",
  "text-button-xl--line-height",
  "text-button-md",
  "text-button-md--line-height",
  "text-button-sm",
  "text-button-sm--line-height",
  "text-chip-xl",
  "text-chip-xl--line-height",
  "text-chip-sm",
  "text-chip-sm--line-height"
], e = [
  "text-transparent",
  "text-current",
  "text-white",
  "text-black",
  "text-grey",
  "text-gray",
  "text-gray-light",
  "text-gray-lighter",
  "text-gray-bg-disabled",
  "text-gray-text-disabled",
  "text-background",
  "text-foreground",
  "text-primary",
  "text-primary-foreground",
  "text-primary-100",
  "text-primary-90",
  "text-primary-80",
  "text-primary-70",
  "text-primary-60",
  "text-primary-50",
  "text-primary-40",
  "text-primary-30",
  "text-primary-20",
  "text-primary-10",
  "text-primary-5",
  "text-dark-100",
  "text-dark-90",
  "text-dark-80",
  "text-dark-70",
  "text-dark-60",
  "text-dark-50",
  "text-dark-40",
  "text-dark-30",
  "text-dark-20",
  "text-dark-10",
  "text-dark-5",
  "text-green",
  "text-pink",
  "text-orange",
  "text-orange-red",
  "text-orange-1",
  "text-orchid",
  "text-purple",
  "text-indigo",
  "text-gold",
  "text-gold-1",
  "text-yellow-light",
  "text-gold-premium",
  "text-blue-dark",
  "text-kids-coral",
  "text-kids-yellow",
  "text-kids-pink",
  "text-kids-blue",
  "text-accent",
  "text-accent-foreground",
  "text-accent-lime",
  "text-accent-orange",
  "text-accent-mint",
  "text-accent-sky-blue",
  "text-accent-lavender-haze",
  "text-secondary",
  "text-secondary-foreground",
  "text-destructive",
  "text-muted",
  "text-muted-foreground",
  "text-ring",
  "text-input",
  "text-border",
  "text-popover",
  "text-popover-foreground",
  "text-card",
  "text-card-foreground",
  "text-sidebar-ring",
  "text-sidebar-border",
  "text-sidebar-accent",
  "text-sidebar-accent-foreground",
  "text-sidebar-primary",
  "text-sidebar-primary-foreground",
  "text-sidebar",
  "text-sidebar-foreground",
  "text-chart-1",
  "text-chart-2",
  "text-chart-3",
  "text-chart-4",
  "text-chart-5"
];
export {
  e as customColorClasses,
  t as customTextSizes
};
